import { render, staticRenderFns } from "./PtiCloud.vue?vue&type=template&id=1482cd8c&scoped=true&"
import script from "./PtiCloud.vue?vue&type=script&lang=js&"
export * from "./PtiCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482cd8c",
  null
  
)

export default component.exports